import React, { useEffect, useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    LoadCcReviewReviewTypeById,
    initCcReviewReviewType,
    setCcReviewReviewTypeReloadEdit,
    setCcReviewReviewTypeEdit,
} from "client/store"
import {
    Container,
    PageHeader,
    PageTitle,
    PageContent,
    Loader,
} from "client/components"

import NotFound from "client/parts/notFound"
import Form from "./form"

interface TypeEditProps {
    typeId: number
    editAccess: boolean
}

const Edit = ({
    typeId,
    editAccess,
}: TypeEditProps) => {
    const project = useSelector((state: StoreType) => state.project.projectView)
    const type = useSelector((state: StoreType) => state.ccReviewReviewType.typeEdit)
    const reloadEdit = useSelector((state: StoreType) => state.ccReviewReviewType.reloadEdit)

    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [loadState, setLoadState] = useState<StateType>(IDLE)

    const reload = () => {
        dispatch(setCcReviewReviewTypeReloadEdit(false))
        setTimeout(() => {
            dispatch(setCcReviewReviewTypeReloadEdit(true))
        }, 0)
    }

    useEffect(() => {
        if (typeId === 0) {
            dispatch(setCcReviewReviewTypeEdit(initCcReviewReviewType))
            reload()
        } else {
            setLoadState(PENDING)
            LoadCcReviewReviewTypeById(typeId, userData.accountId, project.id).then((res) => {
                dispatch(setCcReviewReviewTypeEdit(res))
                setLoadState(IDLE)
                reload()
            })
        }
    }, [])

    if (!type) return <NotFound />
    return (
        <Container>
            <PageHeader>
                <PageTitle>
                    {
                        type.id
                            ? (editAccess ? `${lang.editType} #${type.id}` : `${lang.viewType} #${type.id}`)
                            : lang.addType
                    }
                </PageTitle>
            </PageHeader>
            <PageContent>
                {loadState === PENDING && <Loader />}
                {
                    !reloadEdit
                    && <Form type={type} editAccess={editAccess} />
                }
                {
                    reloadEdit
                    && <Form type={type} editAccess={editAccess} />
                }
            </PageContent>
        </Container>
    )
}
export default Edit
